import React from 'react';
import { Redirect } from 'react-router-dom';
import type { FeatureFlagKey } from '@todesktop/shared';
import {
  useFeatureFlag,
  useFeatureFlagsLoaded,
} from '../../~reusables/hooks/useFeatureFlag';

/** A page only for people with a boolean flag on; others go home. */
export const FeatureGate: React.FC<{
  children: React.ReactNode;
  flag: Extract<FeatureFlagKey, 'accountTeams' | 'v2Apps'>;
}> = ({ children, flag }) => {
  const enabled = useFeatureFlag(flag);
  // Before flags load they read their defaults, so a direct load or a
  // refresh would bounce home.
  const loaded = useFeatureFlagsLoaded();
  if (!loaded) return null;
  return enabled ? <>{children}</> : <Redirect to="/" />;
};
